import { Col, Form, Input, message, Modal, Row, Select } from "antd";
import { Rule } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { contentDefineApi } from "api/content-define.api";
import { RichTextEditor } from "components/Editor/RichTextEditor";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useRef, useState } from "react";
import { ModalStatus } from "types/modal";
import { ContentDefine, ContentDefineType, ContentDefineTypeTrans } from "types/content-define";
import { observer } from "mobx-react";
import { areaStore } from "store/areaStore";
import { RichTextEditorV2 } from "components/Editor/RichTextEditorV2";

const rules: Rule[] = [{ required: true }];
const { Option } = Select;

export const ContentDefineModal = observer(
  ({
    visible,
    status,
    contentDefine,
    onClose,
    onSubmitOk,
  }: {
    visible: boolean;
    status: ModalStatus;
    contentDefine: Partial<ContentDefine>;
    onClose: () => void;
    onSubmitOk: () => void;
  }) => {
    const [form] = Form.useForm<ContentDefine>();
    const [, setForceUpdate] = useState({});
    const [loading, setLoading] = useState(false);
    // const [content, setContent] = useState("");
    const editorRef = useRef<{ setContent: (content: string) => void }>(null);
    const isEditorInit = useRef(false);

    useEffect(() => {
      if (status == "create" && visible) {
        form.resetFields();
      } else {
      }
      // setContent(contentDefine.body || "");
    }, [visible, status]);

    useEffect(() => {
      form.setFieldsValue({ ...contentDefine });
      if (isEditorInit.current) {
        editorRef.current?.setContent(contentDefine.body || "");
      }
      setForceUpdate({});
    }, [contentDefine]);

    const createData = async () => {
      const valid = await form.validateFields();
      const data = {
        contentDefine: {
          ...form.getFieldsValue(),
          // body: content,
        },
      };

      setLoading(true);
      try {
        const res = await contentDefineApi.create(data);
        message.success("Tạo mới thành công!");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const updateData = async () => {
      const valid = await form.validateFields();
      console.log("form.getFieldsValue()", form.getFieldsValue());

      const data = {
        contentDefine: {
          ...form.getFieldsValue(),
          // body:form.getFieldValue('body') ||  content,
        },
      };

      setLoading(true);
      try {
        const res = await contentDefineApi.update(contentDefine?.id || 0, data);
        message.success("Cập nhật thành công");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    return (
      <Modal
        onCancel={onClose}
        open={visible}
        title={status == "create" ? "Tạo mới nội dung" : "Cập nhật nội dung"}
        style={{ top: 20 }}
        width={1200}
        cancelText="Đóng"
        okText="Lưu"
        confirmLoading={loading}
        onOk={() => {
          status == "create" ? createData() : updateData();
        }}
      >
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Loại" name="type" rules={rules}>
                <Select disabled={status == "update"} style={{ width: "100%" }}>
                  <Option value={ContentDefineType.Faq}>
                    {ContentDefineTypeTrans[ContentDefineType.Faq]}
                  </Option>
                  <Option value={ContentDefineType.TermsOfUse}>
                    {ContentDefineTypeTrans[ContentDefineType.TermsOfUse]}
                  </Option>

                  <Option value={ContentDefineType.Hotline}>
                    {ContentDefineTypeTrans[ContentDefineType.Hotline]}
                  </Option>

                  <Option value={ContentDefineType.About}>
                    {ContentDefineTypeTrans[ContentDefineType.About]}
                  </Option>
                  <Option value={ContentDefineType.Policy}>
                    {ContentDefineTypeTrans[ContentDefineType.Policy]}
                  </Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={16}>
              {form.getFieldValue("type") != ContentDefineType.Hotline ? (
                <Form.Item shouldUpdate noStyle>
                  {() => (
                    <Form.Item required label="Nội dung" name="body">
                      <RichTextEditorV2
                        content={form.getFieldValue("body") || ""}
                        onChange={(val) => {
                          if (form.getFieldValue("type") != ContentDefineType.Hotline) {
                            form.setFieldsValue({
                              body: val,
                            });
                          }
                        }}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              ) : (
                <Form.Item required label="Nội dung" name="body">
                  <Input />
                </Form.Item>
              )}
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  },
);
